'use strict';

const jQuery = require('jquery');

const Translator = require('./../../../../core/translator');
const Container = require('./../../../../core/container');

const designRepo = require('./../../repository/DesignRepository');

const zone = require('./../../../../services/structure/zone');
const fixHeight = require('./../../../../services/fixHeight');
const FormBuilder = require('./../../../../services/form');
const Notifier = require('./../../../../services/notifier');
const Loader = require('./../../../../services/loader');

const onSubmit = function(data) {
   designRepo.getAllColors().done(function(elements) {
      let colors = elements.map((element) => element.color);

      let globalContentColors = {
         'headerColor': data.headerColor ? elements[colors.indexOf(data.headerColor)].id : null,
         'hasHeaderMargin': data.hasHeaderMargin,
         'footerColor': data.footerColor ? elements[colors.indexOf(data.footerColor)].id : null,
         'copyrightColor': data.copyrightColor ? elements[colors.indexOf(data.copyrightColor)].id : null,
      };

      zone.hidePanels(Container.get('$smallPanel'));
      designRepo.updateGlobalContentSettings(globalContentColors).done(function() {
         Notifier.success(Translator.translate('parameters_saved'));
         location.reload();
      });
   });
};

module.exports.onClick = function() {
   let $container = jQuery('<div class="global-content-settings-panel"></div>');

   let $layer = zone.addLayer(Translator.translate('global_content_settings'), $container);

   Loader.start($layer);
   designRepo.getGlobalContentColors().done(function(data) {
      let elements = {
         'headerColor': {
            'label': Translator.translate('header_color'),
            'type': 'color',
            'value': data.header_background_color,
            'showPalette': true,
            'disable_transparent': true,
            'group': {
               'id': 'header_design',
               'title': 'header_settings',
            },
         },
         'hasHeaderMargin': {
            'label': Translator.translate('header_margin'),
            'type': 'switch',
            'value': data.has_header_margin,
            'group': {'id': 'header_design'},
         },
         'footerColor': {
            'label': Translator.translate('footer_color'),
            'type': 'color',
            'value': data.footer_background_color,
            'showPalette': true,
            'group': {
               'id': 'footer_design',
               'title': 'footer_settings',
            },
         },
         'copyrightColor': {
            'label': Translator.translate('copyright_color'),
            'type': 'color',
            'value': data.copyright_background_color,
            'showPalette': true,
            'group': {
               'id': 'copyright_design',
               'title': 'copyright_settings',
            },
         },
      };

      let form = FormBuilder.getForm({
         'elements': elements,
         'form': {
            'submit_class': 'd-none',
         },
      });

      $container.append(form.render());
      Loader.stop($layer);

      form.on('submit', onSubmit.bind(data));

      zone.setFooter($layer, zone.createSubmitButtons({
         onSubmitClick: form.submit.bind(form),
      }));

      fixHeight.fix($container, jQuery(window).height() - 165);
   });
};
